import React from "react";

// Import Ionic
import { IonCol, IonIcon, IonRow } from "@ionic/react";
import { Capacitor } from "@capacitor/core";

// Import Icons
import { bookmark } from "ionicons/icons";

// Import Styles
import classNames from "classnames/bind";
import "./HomeProductsSection.css";
import styles from "./HomeProductsSection.module.scss";

// Import Components
import { Product as TProduct } from "@core/types";
import { ProductsSlider } from "../ProductsSlider/ProductsSlider";
import { useConfig } from "../../providers/config";
import { MainPageProduct } from "@core/components";
import { useTranslation } from "react-i18next";

interface IHomeProductsSection {
  items: TProduct[];
  openProducts: () => void;
  sectionTitle: string;
  buttonTitle: string;
}

const cx = classNames.bind(styles);

const HomeProductsSection: React.FC<IHomeProductsSection> = ({ items, openProducts, sectionTitle, buttonTitle }) => {
  const config = useConfig();
  const { t } = useTranslation();

  const renderItem = (item: TProduct) => {
    return <MainPageProduct product={{ ...item, parentName: item.name }} lazyload={false} />;
  };

  return (
    <div className={cx(config?.cardProduct ? "wrapper_irskom" : "wrapper", "productList")}>
      <IonRow className={cx("top-icon-header", "ion-justify-content-between", "productListWrapper")}>
        <IonCol size="0.5" className={cx("productListBookmark")}>
          <IonIcon icon={bookmark} />
        </IonCol>
        <IonCol className="ion-align-self-center">
          <h5 className={cx("productListTitle")} onClick={openProducts}>
            {sectionTitle}
          </h5>
        </IonCol>
        <span onClick={openProducts} className={cx("ion-hide-md-down ion-text-right", "productListSeeAll")}>
          {t("Shop More")}
        </span>
      </IonRow>
      <ProductsSlider
        items={items}
        renderItem={renderItem}
        extraButtonTitle={t("All")}
        extraButtonHandler={openProducts}
        isHavePagination={Capacitor.getPlatform() === "web"}
        isHaveExtraButton={true}
      />
    </div>
  );
};

export default HomeProductsSection;
